import React from 'react';

import { Button } from './ui/button';

import { descargarFicheroEstatico } from '../movil/descargas';

interface BotonDescargaEstaticaProps {
	/** Ruta dentro de `public/`, con la barra inicial. */
	ruta: string;
	nombre: string;
	className?: string;
	children: React.ReactNode;
}

/**
 * Botón que descarga una plantilla de las que viajan con la aplicación. Existe para que la descarga
 * funcione también dentro de la app móvil, donde un enlace con `download` no hace nada.
 */
const BotonDescargaEstatica: React.FC<BotonDescargaEstaticaProps> = ({
	ruta,
	nombre,
	className,
	children
}) => (
	<Button
		type="button"
		variant="outline"
		size="sm"
		className={className}
		onClick={() => {
			descargarFicheroEstatico({ ruta, nombre }).catch((error: unknown) => {
				console.error(`No se pudo descargar ${nombre}`, error);
			});
		}}
	>
		{children}
	</Button>
);

export default BotonDescargaEstatica;
